var map = {
	"./basket.svg": 190,
	"./big-arrow-right.svg": 191,
	"./big-x.svg": 192,
	"./category-kids-glasses.svg": 193,
	"./category-kids.svg": 194,
	"./category-man-glasses.svg": 195,
	"./category-man.svg": 196,
	"./category-woman-glasses.svg": 197,
	"./category-woman.svg": 198,
	"./checkmark-micro.svg": 199,
	"./checkmark.svg": 200,
	"./chevron-down.svg": 201,
	"./chevron-up.svg": 202,
	"./eye.svg": 203,
	"./facebook.svg": 204,
	"./heart.svg": 205,
	"./instagram.svg": 206,
	"./linkedin.svg": 207,
	"./magnifier.svg": 208,
	"./mail.svg": 209,
	"./pause.svg": 210,
	"./pen.svg": 211,
	"./pin.svg": 212,
	"./slider.svg": 213,
	"./small-arrow-down.svg": 214,
	"./small-arrow-left.svg": 215,
	"./small-arrow-right.svg": 216,
	"./small-minus.svg": 217,
	"./small-plus.svg": 218,
	"./small-x.svg": 219,
	"./zoom.svg": 220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;